import { render } from "./DialogTable.vue?vue&type=template&id=181e61fa&scoped=true"
import script from "./DialogTable.vue?vue&type=script&lang=js"
export * from "./DialogTable.vue?vue&type=script&lang=js"

import "./DialogTable.vue?vue&type=style&index=0&id=181e61fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181e61fa"],['__file',"src/components/h5/layout/DialogTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "181e61fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('181e61fa', __exports__)) {
    api.reload('181e61fa', __exports__)
  }
  
  module.hot.accept("./DialogTable.vue?vue&type=template&id=181e61fa&scoped=true", () => {
    api.rerender('181e61fa', render)
  })

}


export default __exports__